<template>
  <main>
    <div class="app-view-container">
      <el-row>
        <el-col class="app-view-title">
          {{ $t('shipper.title') }}
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <search-filter ref="searchFilter" />
        </el-col>
      </el-row>
      <el-row class="search-summary-container bg-white">
        <el-col>
          <el-row class="default-section-header">
            <el-col :span="6" class="default-section-title">
              {{ $t('shipper.summary') }}
               <el-tooltip class="item" effect="dark" :enterable="false" :content="$t('common.refresh')" placement="top-start">
                <el-button @click="handleRefresh" icon="el-icon-refresh" size="mini" class="button-action-default search-summary-refresh-button"></el-button>
              </el-tooltip>
            </el-col>
            <el-col :span="18" class="default-section-actions text-align-end">
              <shipper-group-bulk-update />
              <shipper-cutoff-group-bulk-update />
            </el-col>
          </el-row>
          <el-row class="search-summary">
            <el-col>
              <search-summary />
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>
  </main>
</template>

<script>
import ShipperCutoffGroupBulkUpdate from '@/views/warehouse/shippers/components/ShipperCutoffGroupBulkUpdate';
import SearchFilter from './SearchFilter';
import SearchSummary from './SearchSummary';
import ShipperGroupBulkUpdate from './components/ShipperGroupBulkUpdate';

export default {
  name: 'shipperPage',
  components: {
    ShipperCutoffGroupBulkUpdate,
    SearchFilter,
    SearchSummary,
    ShipperGroupBulkUpdate
  },
  methods: {
    handleRefresh() {
      this.$refs.searchFilter.handleSearch();
    }
  }
};
</script>
